import script from "./FeedBack.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedBack.vue?vue&type=script&setup=true&lang=js"

import "./FeedBack.vue?vue&type=style&index=0&id=410c8a89&scoped=true&lang=css"

import exportComponent from "E:\\project\\exam\\web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-410c8a89"]])

export default __exports__